import React from "react";
import { WhatIcanDo } from "../../utils";
const WhatICanDo = () => {
  return (
    <div className="services_container">
      <h2 className="fs-4">WHAT I CAN DO ?</h2>
      <div className="services">
        {WhatIcanDo.map((item, index) => (
          <div className="service" key={index}>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatICanDo;
